import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Bowser from 'bowser';
import { orgId } from 'utils';
import { I18N, I18NContext, GlobalContext } from 'commons';
import { getParam } from '../../utils/ebUtils';
import SignUpForm from './SignUpForm';

const SignUp = ({ location }) => {
  const { state } = location;

  const i18n = useContext(I18NContext);
  const {
    organization: {
      isPublic, isRecipientExist, memberApp
    },
  } = useContext(GlobalContext);
  console.log("index.js");
  const uaParser = Bowser.getParser(navigator.userAgent);
  const platformType = uaParser.getPlatformType(true);
  const isMobileDevice = platformType === 'mobile' || platformType === 'tablet';
  const osName = uaParser.getOSName(true);

  const referrerInUrl = getParam('referrer');
  const [serverRegionInUrl, setServerRegionInUrl] = useState('US');

  const decodedReferrer = decodeURIComponent(referrerInUrl);

  const appUrlForIOS = isPublic ? `Everbridge://com.everbridge.mobile.iv.Recipient.register?orgId=${orgId}&serverRegion=${serverRegionInUrl || ''}` : `Everbridge://com.everbridge.mobile.iv.Recipient.register?${decodedReferrer}`;
  const appUrlForAndroid = isPublic ? `/downloadapp?orgId=${orgId}&serverRegion=${serverRegionInUrl || ''}` : `/downloadapp?${decodedReferrer || ''}`;

  const appURLs = {
    ios: appUrlForIOS,
    android: `intent://${window.location.hostname}${appUrlForAndroid}#Intent;scheme=https;package=com.everbridge.mobile.iv.recipient;end`
  };

  const onClickConfirmBtn = () => {
    window.location.href = appURLs[osName];
    if (osName === 'ios') {
      setTimeout(() => {
        if (window.confirm(i18n['ssp.download.mobile.app'])) {
          window.location = 'https://itunes.apple.com/cn/app/everbridge-mobile-member/id565859420?mt=8';
        }
      }, 500);
    }
  };

  const onClickViewBtn = (e) => {
    e.preventDefault();
  };

  useEffect(() => {
    if (window.location.hostname.toLowerCase().endsWith('eu')) {
      setServerRegionInUrl('EU')
    }
  }, []);

  useEffect(() => {
    const bannerViewBtn = document.querySelector('.smartbanner-button');
    if (bannerViewBtn) {
      bannerViewBtn.removeEventListener('click', onClickViewBtn);
      bannerViewBtn.addEventListener('click', onClickViewBtn);
    }

    return () => {
      if (bannerViewBtn) {
        bannerViewBtn.removeEventListener('click', onClickViewBtn);
      }
    };
  });

  return (
    <div className="new-registration">
      <a
        href="#main_content"
        className="sr-only sr-only-focusable"
      >
        <I18N>global.skip.to.main.content</I18N>
      </a>
      <main
        id="main_content"
        className="sign-up container ssp-well"
        tabIndex="-1"
        aria-labelledby="registerTitle"
      >
        <h1 id="registerTitle" className="h1 mb-4">
          <I18N>ssp.register.title</I18N>
        </h1>
        <div className="sign-up-container">
          <I18N
            tag="h2"
            className="h2-signup"
            role="form"
            i18n-aria-labelledby="registerTitle"
            i18n-aria-describedby="registrationComment"
          >
              new.registration.signup.create.account.label.createAccount
          </I18N>
          <SignUpForm routerState={state} />
        </div>
      </main>
    </div>
  );
};

SignUp.propTypes = {
  location: PropTypes.shape({
    state: PropTypes.object
  }).isRequired
};

export default SignUp;
